import Hero from "@/components/Hero";
import ProblemSolution from "@/components/ProblemSolution";
import Services from "@/components/Services";
import SoftwareServices from "@/components/SoftwareServices";
import CaseStudies from "@/components/CaseStudies";
import Quoter from "@/components/Quoter";
import Booking from "@/components/Booking";
import { PortfolioHero } from "@/components/portfolio/PortfolioHero";
import { ApiTerminal } from "@/components/portfolio/ApiTerminal";
import { SkillsGrid } from "@/components/portfolio/SkillsGrid";
import { ProjectsSection } from "@/components/portfolio/ProjectsSection";
import { RecruiterForm } from "@/components/portfolio/RecruiterForm";

export const LANDING_BUILTINS = {
  hero: Hero,
  problem: ProblemSolution,
  services: Services,
  software: SoftwareServices,
  cases: CaseStudies,
  quoter: Quoter,
  booking: Booking,
};

export const PORTFOLIO_BUILTINS = {
  p_hero: PortfolioHero,
  p_terminal: ApiTerminal,
  p_skills: SkillsGrid,
  p_projects: ProjectsSection,
  p_contact: RecruiterForm,
};
